import { EventEmitter } from 'events';

interface ChangeValueOptions {
  emitEvents?: ('change' | 'beforeRefresh' | 'refresh')[];
  actionType?: 'add' | 'remove';
  clickedValueKey?: string;
}

export interface ArrayField<T> {
  readonly name: string;
  readonly value: T[];
  readonly events: EventEmitter;
  readonly itemKey: (item: T) => string;
  readonly itemName: (item: T) => string;
  setValue(value: T[], options?: ChangeValueOptions): void;
}
